import { render, staticRenderFns } from "./PreviewInquiry.vue?vue&type=template&id=0bad9c50&scoped=true&"
import script from "./PreviewInquiry.vue?vue&type=script&lang=ts&"
export * from "./PreviewInquiry.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewInquiry.vue?vue&type=style&index=0&id=0bad9c50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad9c50",
  null
  
)

export default component.exports